import { render, staticRenderFns } from "./ResourcePoolInviteDialog.vue?vue&type=template&id=3d1bf78a&"
import script from "./ResourcePoolInviteDialog.vue?vue&type=script&lang=js&"
export * from "./ResourcePoolInviteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports